"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readExpirationTimeInJwt = readExpirationTimeInJwt;
var decodeJwt_1 = require("./decodeJwt");
var tsafe_1 = require("../vendor/frontend/tsafe");
// Return undefined if token provided wasn't a JWT or if it hasn't an exp claim number
function readExpirationTimeInJwt(token) {
    var expirationTime;
    try {
        expirationTime = (0, decodeJwt_1.decodeJwt)(token).exp * 1000;
        (0, tsafe_1.assert)(typeof expirationTime === "number" && !isNaN(expirationTime));
    }
    catch (_a) {
        return undefined;
    }
    return expirationTime;
}
//# sourceMappingURL=readExpirationTimeInJwt.js.map